import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
    rooms: [],
    selectedRoom: {},
    roomsError: null,
}

export const roomsSlice = createSlice({
    name: "rooms",
    initialState,
    reducers: {
        setRooms: (state, action) => {
            state.rooms = action.payload
        },
        setSelectedRoom: (state, action) => {
            state.selectedRoom = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRooms.fulfilled, (state, action) => {
            state.rooms = action.payload
            state.roomsError = 'Get rooms: success'
        })
        builder.addCase(getRooms.rejected, (state, action) => {
            state.roomsError = action.payload
        })
    }
})

export const {
    setRooms,
    setSelectedRoom,
} = roomsSlice.actions

// actions
export const selectRooms = (state) => state.rooms.rooms
export const selectRoom = (state) => state.rooms.selectedRoom
export default roomsSlice.reducer

export const getRooms = createAsyncThunk(
  "rooms/getRooms",
  async () => {
    const res = await fetch(`/data/rooms.json?ts=${Date.now()}`); // served from public/data/rooms.json
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    const data = await res.json();
    return data; // or return `data` if your reducer expects full object
  }
);